<template>
    <div class='microphone-page page'>
        <span class='page-header'>Microphone</span>
        <MicrophoneButton/>
    </div>
</template>

<script>
import MicrophoneButton from '@/components/MicrophoneButton.vue'

export default {
    name: 'Microphone',
    components: {
    	MicrophoneButton
    },
    data: function() {
        return {

        }
    }
}
</script>

<style lang='less'>
</style>